import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminReviewReply({ review, onSaved }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(review.reply?.body || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/reviews/${review.id}/reply`, { reply: text });
      toast.success(data.reply ? "Reply published under the review" : "Reply removed");
      onSaved?.(review.id, data.reply);
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!open) {
    return (
      <div className="mt-2">
        {review.reply?.body && <p className="text-xs text-[#19324A]/70 bg-[#FFF9EE] rounded-lg px-3 py-2 border-l-4 border-[#FFD93D]" data-testid={`admin-review-reply-text-${review.id}`}>🐾 {review.reply.body}</p>}
        <button type="button" onClick={() => setOpen(true)} className="text-xs font-bold text-[#4CC9F0] inline-flex items-center gap-1 mt-1" data-testid={`admin-review-reply-${review.id}`}>
          <MessageSquare className="w-3.5 h-3.5" /> {review.reply?.body ? "Edit reply" : "Reply"}
        </button>
      </div>
    );
  }
  return (
    <div className="mt-2" data-testid={`admin-review-reply-form-${review.id}`}>
      <textarea rows={2} maxLength={1000} value={text} onChange={(e) => setText(e.target.value)} placeholder="Thanks so much — give the pup a scratch from Chewie & Solo!"
        className="w-full rounded-xl border-2 border-[#19324A]/10 px-3 py-2 text-sm outline-none focus:border-[#FFD93D]" data-testid={`admin-review-reply-input-${review.id}`} />
      <div className="flex gap-2 mt-1">
        <button type="button" onClick={save} disabled={busy} className="btn-primary !py-1.5 text-xs disabled:opacity-50" data-testid={`admin-review-reply-save-${review.id}`}>{busy ? "Saving…" : text.trim() ? "Publish reply" : "Remove reply"}</button>
        <button type="button" onClick={() => setOpen(false)} className="text-xs text-[#19324A]/50">Cancel</button>
      </div>
    </div>
  );
}
